import clsx from "clsx";
import React from "react";

interface OptionCardProps {
    isSelected: boolean;
    testId: string;
    title: string;
    description: string;
    onClick: () => void;
}

export const OptionCard = ({ isSelected, testId, title, description, onClick }: OptionCardProps) => (
    <button
        type="button"
        data-testid={testId}
        aria-pressed={isSelected}
        className={clsx(
            "w-full rounded-lg border p-4 text-left",
            isSelected ? "border-blue bg-blue-lighter" : "border-gray-lighter",
        )}
        onClick={onClick}
    >
        <div className="font-bold">{title}</div>
        <div className="text-sm text-gray-dark">{description}</div>
    </button>
);
